import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import queryOrder from '@/components/order/queryOrder'
import orderDetails from '@/components/order/orderDetails'
import payResult from '@/components/order/payResult'
import carNumOrder from '@/components/order/carNumOrder'
import prePay from '@/components/order/prePay'
import bindCar from '@/components/user/bind/bindCar'
import myCar from '@/components/user/bind/myCar'
import appeal from '@/components/user/bind/appeal'
import appealInfo from '@/components/user/bind/appealInfo'
import myWallet from '@/components/user/wallet/myWallet'
import walletPay from '@/components/user/wallet/walletPay'
import record from '@/components/user/parkingRecord/record'
import recordInfo from '@/components/user/parkingRecord/recordInfo'
import detail from '@/components/user/wallet/detail'
import detailInfo from '@/components/user/wallet/detailInfo'
import parkingPay from '@/components/order/parkingPay'
import queryPayFees from '@/components/user/payFees/queryPayFees'
import payFeesRecord from '@/components/user/payFees/payFeesRecord'
import myMenu from '@/components/menu/myMenu.vue'
import advertising from '@/components/advertising.vue'
import useableCoupon from '@/components/coupon/useableCoupon'
import myCoupon from '@/components/coupon/myCoupon'



Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'login', component: login },
    { path: '/queryOrder', name: 'queryOrder', component: queryOrder },
    { path: '/orderDetails', name: 'orderDetails', component: orderDetails },
    { path: '/payResult', name: 'payResult', component: payResult },
    { path: '/carNumOrder', name: 'carNumOrder', component: carNumOrder },
    { path: '/prePay', name: 'prePay', component: prePay },
    { path: '/bindCar', name: 'bindCar', component: bindCar },
    { path: '/parkingPay', name: 'parkingPay', component: parkingPay },
    { path: '/myCar', name: 'myCar', component: myCar },
    { path: '/appeal', name: 'appeal', component: appeal },
    { path: '/appealInfo', name: 'appealInfo', component: appealInfo },
    { path: '/myWallet', name: 'myWallet', component: myWallet },
    { path: '/walletPay', name: 'walletPay', component: walletPay },
    { path: '/record', name: 'record', component: record },
    { path: '/recordInfo', name: 'recordInfo', component: recordInfo },
    { path: '/detail', name: 'detail', component: detail },
    { path: '/detailInfo', name: 'detailInfo', component: detailInfo },
    { path: '/queryPayFees', name: 'queryPayFees', component: queryPayFees },
    { path: '/payFeesRecord', name: 'payFeesRecord', component: payFeesRecord },
    { path: '/myMenu', name: 'myMenu', component: myMenu },
    { path: '/advertising', name: 'advertising', component: advertising },
    { path: '/useableCoupon', name: 'useableCoupon', component: useableCoupon },
    { path: '/myCoupon', name: 'myCoupon', component: myCoupon },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js